import React from "react";
import { Button, NoticeBox, Tags } from "../../ui";
import useBranchApplications from "./useBranchApplications";
import { BRANCH_TAG } from "./applicationsModel";

// Branch Details → Application Accounts: one row per supported application for
// THIS branch only (store.branches[].apps[app]): account id, account name and
// status. Store-level data (store.userInfo / store.appInfo) is not shown. Add /
// Edit open a small modal that sends a request; the live row changes after an
// administrator approves, and the table reloads through the shared workflow.
export default function BranchApplicationAccounts({ branch, storeId, flows }) {
  const { t, canManage, token, revision, ar } = flows;
  const view = useBranchApplications({ token, storeId, branchId: branch.id, revision, enabled: true, t });
  const copy = t.branchAccounts;
  const applications = view.data?.applications || [];

  const openModal = (app, entry) =>
    flows.open("mapping", app, { branchIds: [branch.id], branch: { id: branch.id, name: branch.name || view.data?.branch?.name || "" }, initial: { appId: entry.appId, appName: entry.appName } });

  return (
    <div className="lud-app-stack lud-branch-accounts">
      {view.status === "loading" && <p className="lud-app-lead" role="status">{t.loading}</p>}
      {view.status === "error" && (
        <NoticeBox variant="danger" size="sm">
          {view.error} <Button size="sm" variant="neutral" appearance="soft" onClick={view.reload}>{t.retry}</Button>
        </NoticeBox>
      )}
      {view.status === "ready" && (
        <div className="lud-hours-table-wrap">
          <table className="lud-dashboard-table">
            <thead>
              <tr>
                <th>{copy.colApp}</th>
                <th>{copy.colId}</th>
                <th>{copy.colName}</th>
                <th>{copy.colStatus}</th>
                {canManage && <th>{copy.colActions}</th>}
              </tr>
            </thead>
            <tbody>
              {applications.map((app) => {
                const entry = app.branch;
                const exists = Boolean(entry.appId || entry.appName);
                const locked = Boolean(entry.pendingRequest);
                const name = ar ? app.nameAr : app.nameEn;
                return (
                  <tr key={app.key} data-app={app.key}>
                    <td><strong>{name}</strong></td>
                    <td dir="auto" className="lud-branch-wrap-cell">{exists ? entry.appId || "—" : "—"}</td>
                    <td dir="auto" className="lud-branch-wrap-cell">{exists ? entry.appName || "—" : "—"}</td>
                    <td>
                      {exists ? (
                        <Tags variant={BRANCH_TAG[entry.integration] || "neutral"} appearance="soft" size="sm">{t.status[entry.integration] || entry.integration}</Tags>
                      ) : (
                        "—"
                      )}
                      {locked && <Tags variant="warning" appearance="soft" size="sm">{copy.pending}</Tags>}
                    </td>
                    {canManage && (
                      <td>
                        <Button size="sm" variant="primary" appearance="soft" disabled={locked} aria-label={`${exists ? copy.edit : copy.add} — ${name}`} onClick={() => openModal(app, entry)}>
                          {exists ? copy.edit : copy.add}
                        </Button>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {canManage && <small className="lud-app-hint">{copy.approvalNote}</small>}
    </div>
  );
}
